import { CustomCarrierCodes } from "@jti/commerce/shared";
import type { MagentoShippingMethod } from "@jti/magento-types";

export const isDeliveryOptionSelectable = (
  { available, disableForSubscription }: MagentoShippingMethod,
  isSubscription?: boolean
): boolean => available && (!disableForSubscription || isSubscription === false);

export const prepareDeliveryOptions = (
  unsortedOptions: MagentoShippingMethod[],
  isSubscription = false
): MagentoShippingMethod[] => {
  const options = unsortedOptions.filter(({ carrierCode }) => carrierCode !== CustomCarrierCodes.jtiPickup);

  if (!isSubscription) return options;

  const availableOptions = options.filter(({ disableForSubscription }) => !disableForSubscription);
  const unavailableOptions = options.filter(({ disableForSubscription }) => disableForSubscription);

  return [...availableOptions, ...unavailableOptions];
};
